import { render, staticRenderFns } from "./blind.vue?vue&type=template&id=2bdcaa9c&scoped=true"
import script from "./blind.vue?vue&type=script&lang=js"
export * from "./blind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdcaa9c",
  null
  
)

export default component.exports